import { render, staticRenderFns } from "vue-vtkjs-template/src/components/core/App/template.html?vue&type=template&id=93a02d5c&"
import script from "vue-vtkjs-template/src/components/core/App/script.js?vue&type=script&lang=js&"
export * from "vue-vtkjs-template/src/components/core/App/script.js?vue&type=script&lang=js&"
import style0 from "vue-vtkjs-template/src/components/core/App/style.css?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports